import { useState, useEffect } from 'react';

const gameOptions = {
  0: 'mr-sword', // Sunday
  1: 'roidz', // Monday
  2: 'pixel-jumper', // Tuesday
};

export default function MiniHeaderGames() {
  const gamePath = '/house-games/';
  const htmlFile = '/index.html';
  const iFrameId = 'iog-mini-header-game';

  const [overrideDay, setOverrideDay] = useState(() => {
    if (typeof window !== 'undefined' && typeof window.overrideMiniGameDay === 'number') {
      return window.overrideMiniGameDay;
    }
    return new Date().getDay();
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.updateDayForHeaderGame = (dayIndex) => {
        setOverrideDay(dayIndex);
      };
    }
  }, []);

  const gameArray = Object.values(gameOptions);
  const gameUrl = gameArray[overrideDay % gameArray.length];

  const fullGameUrl = `${gamePath}${gameUrl}${htmlFile}`;

  return (
    <iframe
      id={iFrameId}
      src={fullGameUrl}
      type="text/html"
      style={{
        width: '750px',
        height: '100px',
        margin: '0 1rem',
        border: 'none',
      }}
      
    ></iframe>
  );
}